const FBTURLMap = new Map([
    ["mb1-bracket", "mb1-bracket"],
    ["mb6", "mb6"],
    ["mb10-bracket", "mb10-bracket"],
    ["mb1-p", "mb1-p"],
    ["mb3u", "mb3u"],
    ["mb3", "mb3"],
    ["mb5",  "mb5"],
    ["mb2", "mb2"],
    ["mb-pb-premium-base-mounting-bracket", "mb-pb-premium-base-mounting-bracket"],
    ["mb8-bracket", "mb8-bracket"],
    ["mb14-bracket", "mb14-bracket"],
    ["mb9-bracket", "mb9-bracket"],
    ["mb6-p-bracket", "mb6-p-bracket"],
    ["mb50u-mounting-bracket", "mb50u-mounting-bracket"],
    ["mb36sm-mounting-bracket", "mb36sm-mounting-bracket"],
    ["mb50-mounting-bracket", "mb50-mounting-bracket"],
    ["pulley-lifting-cables-for-linear-actuators", "pulley-lifting-cables-for-linear-actuators"],
    ["mb36", "mb36"],
    ["mb36c", "mb36c"],
    ["mb50c", "mb50c"],
    ["mb35-mounting-bracket", "mb35-mounting-bracket"],
    ["mb7", "mb7"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "mb-17-mounting-bracket-for-super-duty-actuators"],
    ["synchronous-control-board", "synchronous-control-board"],
    ["rocker-switches-for-linear-actuators-momentary-and-sustaining" , "rocker-switches-for-linear-actuators-momentary-and-sustaining"],
    ["toggle-switch", "toggle-switch"],
    ["two-channel-remote-control-system", "two-channel-remote-control-system"],
    ["four-channel-remote-control-system", "four-channel-remote-control-system"],
    ["external-limit-switch-kit-for-actuators", "external-limit-switch-kit-for-actuators"],
    ["dc-power-adaptor", "dc-power-adaptor"],
    ["ac-to-dc-power-adaptor-12v-30a", "ac-to-dc-power-adaptor-12v-30a"],
    ["mb-20-mounting-bracket-for-super-duty-actuators", "mb-20-mounting-bracket-for-super-duty-actuators"],
    ["mb-21-bracket-for-super-duty-actuators", "mb-21-bracket-for-super-duty-actuators"]
]);

const FBTNameMap = new Map([
    ["mb1-bracket", "MB1 Bracket"],
    ["mb6", "MB6 Body Bracket"],
    ["mb10-bracket", "MB10 Bracket for Rod end actuators"],
    ["mb1-p", "MB1-P Mounting Bracket for P-series Actuator"],
    ["mb3u", "MB3U Bracket"],
    ["mb3", "MB3 Bracket"],
    ["mb5",  "MB5 Bracket"],
    ["mb2", "MB2 Bracket"],
    ["mb-pb-premium-base-mounting-bracket", "P-series Base Mounting Bracket"],
    ["mb8-bracket", "MB8 Bracket"],
    ["mb14-bracket", "MB14 Bracket"],
    ["mb9-bracket", "MB9 Bracket"],
    ["mb6-p-bracket", "MB6-P body brackets for P-series actuators"],
    ["mb50u-mounting-bracket", "MB50U Mounting Bracket"],
    ["mb36sm-mounting-bracket", "MB36SM Mounting Bracket"],
    ["mb50-mounting-bracket", "MB50 Mounting Bracket"],
    ["pulley-lifting-cables-for-linear-actuators", "Pulley Lifting Cables for Linear Actuators"],
    ["mb36", "MB36 Mounting Bracket"],
    ["mb36c", "MB36C Mounting Clamp Bracket"],
    ["mb50c", "MB50C Mounting Clamp Bracket"],
    ["mb35-mounting-bracket", "MB35 Mounting Bracket"],
    ["mb7", "MB7 Micro Motor Bracket"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "MB-17 Mounting Bracket For Super Duty Actuators"],
    ["synchronous-control-board", "Actuator Control Board with LCD Screen Interface"],
    ["rocker-switches-for-linear-actuators-momentary-and-sustaining" , "Momentary Rocker Switches for Linear Actuators"],
    ["toggle-switch", "Momentary Toggle Switch for Actuators"],
    ["two-channel-remote-control-system", "Two Channel Remote Control System"],
    ["four-channel-remote-control-system", "Four Channel Remote Control System"],
    ["external-limit-switch-kit-for-actuators", "External Limit-Switch Microswitch Kit"],
    ["dc-power-adaptor", "DC Power Adaptor 12v"],
    ["ac-to-dc-power-adaptor-12v-30a", "Water Resistant LED Power Supply"],
    ["mb-20-mounting-bracket-for-super-duty-actuators", "MB20 Mounting Bracket for Super Duty Actuators"],
    ["mb-21-bracket-for-super-duty-actuators", "MB21 Body Bracket for Super Duty Actuators"]
]);
//doesnt have mb-18
const FBTPriceMap = new Map([
    ["mb1-bracket", "$9.80 CAD"],
    ["mb6", "$12.00 CAD"],
    ["mb10-bracket", "$22.90 CAD"],
    ["mb1-p", "$11.00 CAD"],
    ["mb3u", "$13.00 CAD"],
    ["mb3", "$10.15 CAD"],
    ["mb5",  "$23.00 CAD"],
    ["mb2", "$7.00 CAD"],
    ["mb-pb-premium-base-mounting-bracket", "$13.35 CAD"],
    ["mb8-bracket", "$13.00 CAD"],
    ["mb14-bracket", "$6.00 CAD"],
    ["mb9-bracket", "$8.00 CAD"],
    ["mb6-p-bracket", "$11.50 CAD"],
    ["mb50u-mounting-bracket", "$29.75 CAD"],
    ["mb36sm-mounting-bracket", "$22.80 CAD"],
    ["mb50-mounting-bracket", "$36.90 CAD"],
    ["pulley-lifting-cables-for-linear-actuators", "$18.00 CAD"],
    ["mb36", "$21.60 CAD"],
    ["mb36c", "$14.30 CAD"],
    ["mb50c", "$15.25 CAD"],
    ["mb35-mounting-bracket", "$14.25 CAD"],
    ["mb7", "$3.00 CAD"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "$12.80 CAD"],
    ["synchronous-control-board", "$330.95 CAD"],
    ["rocker-switches-for-linear-actuators-momentary-and-sustaining" , "$5.50 CAD"],
    ["toggle-switch", "$12.00 CAD"],
    ["two-channel-remote-control-system", "$60.00 CAD"],
    ["four-channel-remote-control-system", "$75.00 CAD"],
    ["external-limit-switch-kit-for-actuators", "$25.25 CAD"],
    ["dc-power-adaptor", "$58.00 CAD"],
    ["ac-to-dc-power-adaptor-12v-30a", "$118.00 CAD"],
    ["mb-20-mounting-bracket-for-super-duty-actuators", "$36.45 CAD"],
    ["mb-21-bracket-for-super-duty-actuators", "$36.45 CAD"]
]);
const FBTImageMap = new Map([
    ["mb1-bracket", "https://cdn.shopify.com/s/files/1/0615/2193/files/MB1_2_1280x_1.webp?v=1699567868"],
    ["mb6", "https://cdn.shopify.com/s/files/1/0615/2193/files/MB6_0d8cf65a-3c66-4917-afea-db422a69de66_800x_1.webp?v=1699568109"],
    ["mb10-bracket", "https://cdn.shopify.com/s/files/1/0615/2193/products/image0_22_1280x.jpg?v=1622240178"],
    ["mb1-p", "//cdn.shopify.com/s/files/1/0615/2193/products/MB1_1_de63d421-2114-48cf-9576-b835b39bd4d4_300x300.jpg?v=1495598484"],
    ["mb3u", "//cdn.shopify.com/s/files/1/0615/2193/products/MB3U_3_300x300.jpg?v=1617728234"],
    ["mb3", "//cdn.shopify.com/s/files/1/0615/2193/products/MB3_1_300x300.jpg?v=1596130635"],
    ["mb5",  "//cdn.shopify.com/s/files/1/0615/2193/products/MB5_cropped_aa50f050-da9b-47a5-901a-1bf800cac563_300x300.jpg?v=1674769435"],
    ["mb2", "//cdn.shopify.com/s/files/1/0615/2193/products/MB2_1_300x300.jpg?v=1596130641"],
    ["mb-pb-premium-base-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/Premium_Base_Bracket_300x300.jpg?v=1551725579"],
    ["mb8-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB8_Cropped_300x300.jpg?v=1596130687"],
    ["mb14-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB14_3_300x300.jpg?v=1596130649"],
    ["mb9-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB9_408ffe6d-9537-4a99-85f5-9b9593e60ab7_300x300.jpg?v=1596130711"],
    ["mb6-p-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/image0_29_300x300.jpg?v=1622237009"],
    ["mb50u-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB50U5_300x300.jpg?v=1622060559"],
    ["mb36sm-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/BDQE2902_300x300.jpg?v=1596130609"],
    ["mb50-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/DAYW3403_300x300.jpg?v=1596130589"],
    ["pulley-lifting-cables-for-linear-actuators", "//cdn.shopify.com/s/files/1/0615/2193/products/lifting_pulley_cable_300x300.jpg?v=1596131162"],
    ["mb36", "//cdn.shopify.com/s/files/1/0615/2193/products/YIIX1658_300x300.jpg?v=1596130625"],
    ["mb36c", "//cdn.shopify.com/s/files/1/0615/2193/products/LQFK7531-Recovered_300x300.jpg?v=1596130613"],
    ["mb50c", "//cdn.shopify.com/s/files/1/0615/2193/products/AJLI5797_300x300.jpg?v=1596130668"],
    ["mb35-mounting-bracket", "//cdn.shopify.com/s/files/1/0615/2193/products/MB351_300x300.jpg?v=1647380840"],
    ["mb7", "//cdn.shopify.com/s/files/1/0615/2193/products/Jan_29-Select-Hi_Res-28_300x300.jpg?v=1596130679"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "//cdn.shopify.com/s/files/1/0615/2193/products/mb17_300x300.jpg?v=1679346170"],
    ["synchronous-control-board", "//cdn.shopify.com/s/files/1/0615/2193/files/Syncboard_1_1_-min_1600x_1.webp?v=1700161531"],
    ["rocker-switches-for-linear-actuators-momentary-and-sustaining" , "//cdn.shopify.com/s/files/1/0615/2193/files/rocker-switch_1.webp?v=1701297255"],
    ["toggle-switch", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-Toogle_1728x_1.webp?v=1701297635"],
    ["two-channel-remote-control-system", "//cdn.shopify.com/s/files/1/0615/2193/files/2CH-REMOTE-CONTROL-OP_360x_53e3fb57-7672-4d07-a0e3-fa4d63f1bf00.webp?v=1701298439"],
    ["four-channel-remote-control-system", "//cdn.shopify.com/s/files/1/0615/2193/files/4CH-RC_1944x_1.webp?v=1701303114"],
    ["external-limit-switch-kit-for-actuators", "//cdn.shopify.com/s/files/1/0615/2193/files/EL-kit.webp?v=1701466060"],
    ["dc-power-adaptor", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-PA-12V-12A_1600x_1.webp?v=1701712697"],
    ["ac-to-dc-power-adaptor-12v-30a", "//cdn.shopify.com/s/files/1/0615/2193/files/FA-PA-12V-30A-IP66_Power_Supply_1600x_1.webp?v=1701716576"],
    ["mb-20-mounting-bracket-for-super-duty-actuators", "//cdn.shopify.com/s/files/1/0615/2193/files/IMG_0527_3024x_9cb8eb41-5bc4-4bd4-966f-e1695fa9b605.webp?v=1723155346"],
    ["mb-21-bracket-for-super-duty-actuators", "//cdn.shopify.com/s/files/1/0615/2193/files/IMG_0515_3024x_a667f987-f377-46a4-b061-c7dc896fbfee.webp?v=1723155408"]
]);
//?variant=
const FBTIDMap = new Map([
    ["mb1-bracket", "1095576660"],
    ["mb6", "1095575788"],
    ["mb10-bracket", "38162378784939"],
    ["mb1-p", "20023968900"],
    ["mb3u", "1095575868"],
    ["mb3", "1095575880"],
    ["mb5",  "1095575844"],
    ["mb2", "1095576180"],
    ["mb-pb-premium-base-mounting-bracket", "21857409007721"],
    ["mb8-bracket", "1095575744"],
    ["mb14-bracket", "21438783492"],
    ["mb9-bracket", "1095575732"],
    ["mb6-p-bracket", "39857053761707"],
    ["mb50u-mounting-bracket", "42172711436459"],
    ["mb36sm-mounting-bracket", "38162171003051"],
    ["mb50-mounting-bracket", "38162213404843"],
    ["pulley-lifting-cables-for-linear-actuators", "1095574760"],
    ["mb36", "37966315684011"],
    ["mb36c", "38162273763499"],
    ["mb50c", "38162260197547"],
    ["mb35-mounting-bracket", "42591061377195"],
    ["mb7", "1095575772"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "42590515429547"],
    ["synchronous-control-board", "32025317146729"],
    ["rocker-switches-for-linear-actuators-momentary-and-sustaining", "1095574292"],
    ["toggle-switch", "17107010948"],
    ["two-channel-remote-control-system", "1095572752"],
    ["four-channel-remote-control-system", "1095577656"],
    ["external-limit-switch-kit-for-actuators", "1095577832"],
    ["dc-power-adaptor", "1095578088"],
    ["ac-to-dc-power-adaptor-12v-30a", "21367601791081"],
    ["mb-20-mounting-bracket-for-super-duty-actuators", "55265816904049"],
    ["mb-21-bracket-for-super-duty-actuators", "55265817231729"]


    //fg-product-form__variant-group uk-fieldset js-product-variants
]);